<template>
  <v-card>
    <v-card-title>
      Vorgänge
      <v-btn color="primary" class="ml-3" @click="createOffer()">
        <v-icon> mdi-cart-plus </v-icon>
        neue Preisinformation
      </v-btn>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Suche"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="datasets"
      :search="search"
      sort-by="updated_at"
      sort-desc
      :items-per-page="50"
      :footer-props="{
        itemsPerPageOptions: [-1, 50, 100],
      }"
    >
      <template #[`header.status`]="{ header }">
        <TableFilter
          v-model="tableFilters.status"
          :items="leads"
          :header="header"
        />
        {{ header.text }}
      </template>
      <template #[`header.source`]="{ header }">
        <TableFilter
          v-model="tableFilters.source"
          :items="leads"
          :header="header"
        />
        {{ header.text }}
      </template>
      <template #[`item.actions`]="{ item }">
        <inertia-link v-if="item.deleted_at == null && item.preliminary_pug !== undefined" :href="route('offerData.show', {'offerData': item.id})">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-icon class="mr-3" v-bind="attrs" v-on="on">
                mdi-eye
              </v-icon>
            </template>
            <span>bearbeiten</span>
          </v-tooltip>
        </inertia-link>
        <inertia-link v-if="item.preliminary_pug == undefined" :href="route('offer.show', item.id)">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-icon class="mr-3" v-bind="attrs" v-on="on">
                mdi-eye
              </v-icon>
            </template>
            <span>öffnen</span>
          </v-tooltip>
        </inertia-link>
        <inertia-link v-if="item.deleted_at == null && item.preliminary_pug !== undefined" :href="route('offerData.edit', {'offerData': item.id})">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-icon class="mr-3" v-bind="attrs" v-on="on">
                mdi-pencil
              </v-icon>
            </template>
            <span>bearbeiten</span>
          </v-tooltip>
        </inertia-link>
        <DeleteDialogLead v-if="item.deleted_at == null && item.preliminary_pug !== undefined" :lead="item" />
        <DeleteDialogOffer v-if="item.deleted_at == null && item.preliminary_pug == undefined" :offer="item" />
      </template>
      <template #[`item.created_at`]="{ item }">
        {{ getDateString(item.created_at) }}
      </template>
      <template #[`item.source`]="{ item }">
        <inertia-link v-if="item.source" :href="route('contract.from-number', {'contractNumber': item.source})">
          {{ item.source }}
        </inertia-link>
      </template>
      <template #[`item.title`]="{ item }">
        <inertia-link
          v-if="item.offerData"
          slot=""
          :href="route('offer.show', {'offer': item.id})"
          :style="item.deleted_at == null ? '' : 'pointer-events: none'"
        >
          {{ item.title ? item.title : item.id }}
        </inertia-link>
        <inertia-link
          v-else
          :href="route('offerData.show', {'offerData': item.id})"
          :style="item.deleted_at == null ? '' : 'pointer-events: none'"
        >
          {{ item.title ? item.title : item.id }}
        </inertia-link>
      </template>
      <template #[`item.updated_at`]="{ item }">
        <span>{{ getDateString(item.updated_at) }}</span>
      </template>
      <template #[`item.expected_completion_at`]="{ item }">
        <span>{{
          item.expected_completion_at
            ? getDateString(item.expected_completion_at)
            : null
        }}</span>
      </template>
      <template #[`item.turnover`]="{ item }">
        {{
          item.turnover
            ? new Intl.NumberFormat("de-DE", {
              style: "currency",
              currency: "EUR",
            }).format(item.turnover)
            : "-"
        }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import TableFilter from '@/Components/Customer/Offers/TableFilter'
import DeleteDialogLead from '@/Components/Customer/Offers/DeleteDialogLead'
import { formattedDateString } from '@/plugins/formatDate.js'
export default {
   components: {
      TableFilter,
      DeleteDialogLead,
   },
   props: {
      leads: {
         type: Array,
         required: true,
      },
      customer: {
         type: Object,
         required: true,
      },
      processes: {
         type: Array,
         required: true
      }
   },
   data () {
      return {
         search: '',
         headers: [
            { text: 'Nr', value: 'title' },
            { text: 'Inhalt', value: 'content' },
            {
               text: 'Status',
               value: 'status',
               filter: (value) => {
                  if (this.tableFilters.status.length === 0) return true

                  return this.tableFilters.status.includes(value)
               },
            },
            {
               text: 'Quelle',
               value: 'source',
               //    filter: (value) => {
               //       if (this.tableFilters.source.length === 0) return true
               //       console.log(value)
               //       return this.tableFilters.source.includes(value)
               //    },
            },
            { text: 'Betrag', value: 'turnover' },
            { text: 'Ablaufdatum', value: 'invalid_at' },
            { text: 'vsl. Abschluss', value: 'expected_completion_at' },
            { text: 'Erstelldatum', value: 'created_at' },
            { text: 'Updated', value: 'updated_at' },
            { text: 'gewünschte Umsetzung', value: 'planned_completion_at' },

            { text: '', value: 'actions', sortable: false, width: '170px' },
         ],
         tableFilters: {
            status: [],
            source: [],
         },
      }
   },
   computed: {
      datasets () {
         const sets = []
         this.leads.forEach(function (val) {
            if (val.status !== 'verworfen') sets.push(val)
         })
         console.log(sets)
         return sets.concat(this.processes)
      }
   },
   methods: {
      getDateString (dateVal) {
         return formattedDateString(dateVal)
      },
      createOffer () {
         this.$inertia.post(this.route('offerData.store', this.customer.id))
      },
   }
}
</script>

<style>
</style>
